<template>
  <div v-if="modelValue.length > 0">
    <p v-if="title" class="editor-title">{{ title }}</p>

    <div v-for="(item, index) in modelValue" :key="getItemKey(item, index)">
      <t-form-item
        :name="`${formItemNamePrefix}[${index}].${valueField}`"
        style="margin-bottom: 10px"
      >
        <select-with-operate
          :model-value="getItemValue(item)"
          :include-input-variables="includeInputVariables"
          :hide-create-button="hideCreateButton"
          @update:modelValue="updateItemValue(index, $event)"
        />
        <CloseCircleIcon
          size="16"
          style="cursor: pointer; margin-left: 15px; margin-top: -2px"
          @click="removeItem(index)"
        />
      </t-form-item>
    </div>
  </div>

  <div v-if="modelValue.length < maxItems" :style="linkWrapperStyle">
    <t-link theme="primary" hover="color" @click="appendItem">
      {{ addText }}
    </t-link>
  </div>
</template>

<script lang="ts" setup>
import { cloneDeep } from "lodash-es";
import { CloseCircleIcon } from "tdesign-icons-vue-next";
import SelectWithOperate from "./select-with-operate.vue";

const props = withDefaults(
  defineProps<{
    modelValue: Array<Record<string, any>>;
    valueField: string;
    formItemNamePrefix: string;
    addText: string;
    createItem: () => Record<string, any>;
    title?: string;
    itemKeyField?: string;
    includeInputVariables?: boolean;
    hideCreateButton?: boolean;
    maxItems?: number;
    linkWrapperStyle?: string;
  }>(),
  {
    title: "",
    itemKeyField: "",
    includeInputVariables: false,
    hideCreateButton: false,
    maxItems: 20,
    linkWrapperStyle: "",
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: Array<Record<string, any>>): void;
}>();

const getItemKey = (item: Record<string, any>, index: number) => {
  if (props.itemKeyField && item?.[props.itemKeyField]) {
    return item[props.itemKeyField];
  }
  return index;
};

const getItemValue = (item: Record<string, any>) => {
  return item?.[props.valueField] ?? "";
};

const updateItemValue = (index: number, value: string) => {
  const nextValue = cloneDeep(props.modelValue);
  nextValue[index] = {
    ...nextValue[index],
    [props.valueField]: value,
  };
  emit("update:modelValue", nextValue);
};

const appendItem = () => {
  emit("update:modelValue", [...cloneDeep(props.modelValue), props.createItem()]);
};

const removeItem = (index: number) => {
  const nextValue = cloneDeep(props.modelValue);
  nextValue.splice(index, 1);
  emit("update:modelValue", nextValue);
};
</script>

<style lang="less" scoped>
.editor-title {
  color: #6d778c;
  margin-bottom: 8px;
}
</style>
